import styled from 'styled-components'

import { Table } from '@radix-ui/themes'
import { DropdownMenu } from '@radix-ui/themes'

export const StyledTable = styled.div`
    width: 100%;

    .rt-TableRoot, table {
        border: none;
        width: 100%;
    }

    table {
        border-collapse: collapse;

        thead {
            tr,
            th {
                font-weight: 500;
                padding-bottom: 0.5rem;
                border-bottom: 0.1rem solid var(--gray-6);
            }
            background-color: var(--gray-1);

            .table__selectable-headercell {
                line-height: 100%;
                vertical-align: middle;
                width: 2rem;
            }
        }

        th,
        td {
            padding: 0.5rem;
            text-align: center;
            position: relative;
            height: 2rem;
            line-height: 2rem;
            background-color: var(--gray-1);
        }

        th.sortable-column {
            cursor: pointer;
        }

        tbody {
            td {
                color: var(--gray-11);
                padding-inline: 1rem;
            }

            position: relative;

            tr:nth-child(even) {
                background-color: var(--gray-2);
            }

            tr:hover,
            tr[data-state='open'] {
                background-color: var(--gray-4);
            }

            td > button {
                color: var(--gray-9);
            }

            td.fixed {
                background-color: var(--gray-1);
            }

            tr:hover {
                .fixed {
                    background-color: var(--gray-4);
                }
            }

            .table__expand-button {
                width: 2rem;
            }

            .table__selectable-cell {
                width: 2rem;
                line-height: 100%;
                vertical-align: middle;
            }
        }

        th.rt-TableCell {
            padding-top: 0;
        }
    }

    .filter-icon {
        margin-left: 0.5rem;
    }

    .tableFooter {
        line-height: 0.4rem;
        font-size: 1rem;
        background-color: var(--gray-1);
        text-align: right;
        font-weight: normal;
    }
`

export const StyledFooter = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    padding-right: 1rem;
    color: gray;
    button:not(:disabled) {
        cursor: pointer;
    }
`

export const StyledFooterRow = styled.tr`
    position: sticky;
    bottom: 0;
    z-index: 2;
    background-color: var(--gray-3) !important;
    box-shadow: inset 0 1px 0 var(--gray-5);
    cursor: default;
    user-select: text;

    td {
        background-color: var(--gray-3) !important;
        color: var(--gray-11);
        cursor: default;
    }
`

export const TableLoader = styled(Table.Cell)`
    padding: 2rem !important;
`

export const TableActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;

    button {
        margin-inline: 0.2rem;
    }
`

export const TableGlobalActionButtonContainer = styled.div`
    display: flex;
    gap: 0.5rem;

    &:not(:empty) {
        margin-bottom: 0.5rem;
    }
`

export const TableActionsDropdownMenuContent = styled(DropdownMenu.Content)`
    box-shadow: 0px 0px 5px 2px var(--accent-11);

    .rt-DropdownMenuViewport {
        padding: 0;

        > div[role='menuitem'] {
            border-bottom: 1px solid var(--accent-11);

            &:last-child {
                border-bottom: 0;
            }
        }
    }

    .rt-DropdownMenuItem {
        border-radius: 0;
        cursor: pointer;

        /* custom rendered actions bring their own button */
        &:has(> button) {
            padding: 0;
        }

        > button {
            width: 100%;
            border-radius: 0;
        }
    }
`
